<cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten">
  <ng-container title>
    <h2 class="mb-0">{{ "neskoab.Objekte" | translate }}</h2>
  </ng-container>

  <cap-list-loader [defaultText]="'gemaessAmtlicherBewertung'" [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false">
    <div class="cap-list-loader-content">
      <table class="cap-table-detail">
        <thead>
          <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
        </thead>
        <tbody>
          <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </cap-list-loader>
</cap-rubrik>

<ng-template #tableHeaders>
  <tr>
    <th style="width: 7%">{{ "Objekt-Nr." | translate }}</th>
    <th style="width: 15%">{{ "Objektcode" | translate }}</th>
    <th style="width: 15%">{{ "Lagebezeichnung" | translate }}</th>
    <th style="width: 30%">{{ "Objektbezeichnung" | translate }}</th>
    <th style="width: 10%">{{ "Gebaeude-Nr." | translate }}</th>
    <th style="width: 8%">{{ "Flaeche" | translate }}</th>
    <th style="width: 15%">{{ "neskoab.AmtlicherWert" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        {{ item.objektNr }}
      </td>
      <td>
        {{ item.artCode }}
      </td>
      <td>
        {{ item.lagebezeichnung }}
      </td>
      <td>
        {{ item.codeObjektbezeichnung }}
        @if (item.codeObjektbezeichnung && item.kommentar) {
          <span>, </span>
        }
        {{ item.kommentar }}
        @if (item.freitextObjektbezeichnung) {
          <span>
            @if (item.kommentar || item.codeObjektbezeichnung) {
              <span>, </span>
            }
            {{ item.freitextObjektbezeichnung }}</span
          >
        }
      </td>
      <td>
        {{ item.gebaeudeNr }}
      </td>
      <td>{{ item.flaeche | decimalHochkomma }}&nbsp;m²</td>
      <td>
        @if (isAmtlicherWertVerteilt) {
          <span> ({{ item.amtlicherWert | betrag: true : true }}) 0 </span>
        }
        @if (!isAmtlicherWertVerteilt) {
          <span>
            {{ item.amtlicherWert | betrag: true : true }}
          </span>
        }
        @if (item.isKennzeichnungErtragswert && item.amtlicherWert && !item.ertragswertNachBGBB) {
          <span>
            <br />
            {{ "(mit Ertragswertkomponente)" | translate }}
          </span>
        }
      </td>
    </tr>
  }
</ng-template>
